import { todayCheckoutSlots } from '@/features/checkout/checkoutSlots';
import { currentPeriod, slotPeriod, type Period, type WeeklyHours } from './servicePeriod';
import type { Closure, FirstSlotConfig } from '@/types/restaurant';

/** Period to filter the PRE-ORDER menu by.
 *
 *  Inside a service, this is simply the current period — same as before. The
 *  fix is the BETWEEN-services window (e.g. 15h–17h): `currentPeriod` says
 *  'closed' there, and `filterMenuByPeriod(menu, 'closed')` shows the full
 *  menu — so a midi-only dish stayed addable at 16h10 when only dinner slots
 *  remained, and the customer only hit the wall at checkout. Here we derive
 *  the period from the slots still orderable TODAY instead: only dinner slots
 *  left → filter as 'dinner' (midi-only dishes hidden, consistent with the
 *  checkout slot filter and the cart-drawer warning).
 *
 *  When the remaining slots span both periods, or none remain (done for the
 *  day / closure day — browsing only), returns 'closed' so the full menu
 *  stays visible, exactly as before.
 */
export function menuFilterPeriod(
  hours: WeeklyHours | null | undefined,
  now: Date,
  closures: Closure[],
  prepMinutes: number,
  tz?: string,
  firstSlot: FirstSlotConfig | null = null,
): Period {
  const current = currentPeriod(now, hours, tz);
  if (current !== 'closed') return current;
  if (!hours) return 'closed';
  const slots = todayCheckoutSlots(hours, now, prepMinutes, undefined, closures, tz, firstSlot);
  const periods = new Set(slots.map(slotPeriod));
  if (periods.size === 1) return periods.has('lunch') ? 'lunch' : 'dinner';
  return 'closed';
}
